import { useConnect } from "./hooks/useConnect";
import { Header } from "./components/Header";
import { Intro } from "./components/Intro";
import { ProviderSelect } from "./components/ProviderSelect";
import { StateSelect } from "./components/StateSelect";
import { CredentialEntry } from "./components/CredentialEntry";
import { ValidationFailed } from "./components/ValidationFailed";
import { Success } from "./components/Success";
import { FatalError } from "./components/FatalError";
import { Loading } from "./components/Loading";

const STEPS_WITH_BACK = new Set(["select_provider", "select_state", "enter_credentials"]);

export default function App() {
  const {
    state,
    isSandbox,
    continueFromIntro,
    selectProvider,
    selectState,
    continueToCredentials,
    updateCredential,
    goBack,
    retryCredentials,
    submitCredentials,
    close,
  } = useConnect();

  return (
    <div className="min-h-screen flex items-start justify-center p-4">
      <div className="w-full max-w-md bg-white border border-gray-300">
        <Header
          onClose={close}
          onBack={STEPS_WITH_BACK.has(state.step) ? goBack : undefined}
          isSandbox={isSandbox}
        />

        <div className="p-6">
          {state.step === "init" && <Loading />}

          {state.step === "intro" && state.session && (
            <Intro
              organizationName={state.session.organizationName}
              organizationLogoUrl={state.session.organizationLogoUrl}
              onContinue={continueFromIntro}
            />
          )}

          {state.step === "select_provider" && state.session && (
            <ProviderSelect providers={state.session.providers} onSelect={selectProvider} />
          )}

          {state.step === "select_state" && state.selectedProvider && (
            <StateSelect
              provider={state.selectedProvider}
              selectedState={state.selectedState}
              onSelectState={selectState}
              onContinue={continueToCredentials}
            />
          )}

          {state.step === "enter_credentials" && state.selectedProvider && (
            <CredentialEntry
              provider={state.selectedProvider}
              credentials={state.credentials}
              submitting={state.submitting}
              isSandbox={isSandbox}
              onChangeCredential={updateCredential}
              onSubmit={submitCredentials}
            />
          )}

          {state.step === "failed" && (
            <ValidationFailed
              message={state.error || "Unable to validate your credentials."}
              onRetry={retryCredentials}
            />
          )}

          {state.step === "success" && state.selectedProvider && (
            <Success
              provider={state.selectedProvider}
              state={state.selectedState || ""}
            />
          )}

          {state.step === "error" && (
            <FatalError message={state.error || "An unknown error occurred."} />
          )}
        </div>

        <div className="px-6 pb-4 text-center">
          <p className="text-xs text-gray-400">
            Secured by <span className="font-medium text-gray-500">SeedLink</span>
          </p>
        </div>
      </div>
    </div>
  );
}
